import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppRouter from "./router/router";
import AlertProvider from "./contexts/alertContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <AlertProvider>
            <AppRouter />
        </AlertProvider>
    </React.StrictMode>
);
